import React from "react";

import { useSelector } from "react-redux";

import TransactionTable from "./TransactionTable";
import FirestRunExperience from "./FirstRunExperience";
const TransactionsPage = () => {
  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  const plaid_items = useSelector(
    (state) => state.firebase.profile.plaid_items
  );

  if (!plaid_items || Object.keys(plaid_items).length === 0)
    return <FirestRunExperience />;
  return <TransactionTable />;
};
export default TransactionsPage;
